import React from 'react';
import classnames from 'classnames';
import { Map, List } from 'immutable';
import PropTypes from 'prop-types';

import { commaFormatNumber } from '@Utils/String';
import Amount from '@Components/Amount';
import ThesaurusItemInfo from '../ThesaurusItemInfo';

import './ThesaurusItem.scss';

export function getPartiallySelectedIndentificator(isRoot, item) {
  return isRoot ? item.get('thesaurusRootId') : item.get('id');
}

function ThesaurusItem(props) {
  const { item, filter, isOpen, isRoot, isFolder, className, onToggleGroup, onClickThesaurusItem, thesaurusGroupsPartiallySelectedMap } =
    props;
  const paddingCount = item.get('rootIds', List()).count();
  const totalCount = filter.get('hitCount');
  const currentCount = item.get('hitCount');
  const title = item.get('title');
  const selected = Boolean(item.get('selected'));
  const currentAmountInPercentages = (currentCount * 100) / totalCount;
  const partiallySelectedIndentificator = getPartiallySelectedIndentificator(isRoot, item);
  const partiallySelected = Boolean(thesaurusGroupsPartiallySelectedMap.get(partiallySelectedIndentificator));

  return (
    <div
      style={{
        paddingLeft: `${paddingCount * 2}rem`,
      }}
      className={classnames(className, 'tree-view-dialog-thesaurus-item')}>
      <div className="tree-view-dialog-thesaurus-item-children-wrapper">
        <ThesaurusItemInfo
          item={item}
          isOpen={isOpen}
          title={title}
          selected={selected}
          isFolder={isFolder}
          onToggleGroup={onToggleGroup}
          partiallySelected={partiallySelected}
          onClickThesaurusItem={onClickThesaurusItem}
        />
      </div>
      <div className="tree-view-dialog-thesaurus-item-info-wrapper">
        <Amount selected={selected || partiallySelected} currentAmountInPercentages={currentAmountInPercentages} />
        <span className="tree-view-dialog-thesaurus-item-info-hit-count">{commaFormatNumber(currentCount)}</span>
      </div>
    </div>
  );
}

ThesaurusItem.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  filter: PropTypes.instanceOf(Map).isRequired,
  isOpen: PropTypes.bool.isRequired,
  isRoot: PropTypes.bool.isRequired,
  isFolder: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onToggleGroup: PropTypes.func.isRequired,
  onClickThesaurusItem: PropTypes.func.isRequired,
  thesaurusGroupsPartiallySelectedMap: PropTypes.instanceOf(Map).isRequired,
};

export default ThesaurusItem;
